export default __webpack_public_path__ + "static/media/Dami.60c51cdf.jpg";